module.exports = __webpack_public_path__ + "img/receive_header.d3f13d4d.jpg";